import { useEffect, useState } from "react";
import AddButton from "../../../../components/AddButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import TableFilters from "../TableFilters";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import {
  addStateCodeLevel,
  editStateCodeLevel,
  selectedRowsStateCodeLevel,
} from "./atoms/atoms";
import useGetCodeLevels from "./hooks/useGetCodeLevel";
import useAddCodeLevel from "./hooks/useAddCodeLevel";
import useDeleteCodeLevel from "./hooks/useDeleteCodeLevel";
import useUpdateCodeLevel from "./hooks/useUpdateCodeLevel";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import MaterialProducerCodeConfigTable from "../../../../components/tables/MaterialProducerCodeConfigTable";

const CodeLevelTable = () => {
  const queryClient = useQueryClient();
  const [codeLevelData, setCodeLevelData] = useState([]);
  const [editRowData, setEditRowData] = useState();
  const [addState, setAddState] = useRecoilState(addStateCodeLevel);
  const [editState, setEditState] = useRecoilState(editStateCodeLevel);
  const [updatedStatus, setUpdatedStatus] = useState(false);

  const newRow = {
    codeLevelId: 0,
    codeLevelName: "",
    createdOn: null,
    createdBy: null,
    isActive: true,
  };

  const [newData, setNewData] = useState([newRow]);

  const [openModal, setOpenModal] = useState(false);

  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateCodeLevel
  );
  const [rowsCount, setRowsCount] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [, setDisabledButton] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [disableSave, setDisableSave] = useState(true);
  const CodeLevelData = useGetCodeLevels();
  const BulkDeleteCodeLevel = useDeleteCodeLevel();
  const editCodeLevel = useUpdateCodeLevel();
  const { mutateAsync: addCodeLevel } = useAddCodeLevel();
  const [codeLevelFilteredData, setCodeLevelFilteredData] = useState([]);
  const [, setMgaFilteredData] = useState([]);
  const [, setProdCodeTypeFilteredData] = useState([]);
  const [, setLOBTypeFilteredData] = useState([]);
  const [, setDisChannelFilteredData] = useState([]);
  const [, setCProgramFilteredData] = useState([]);

  //Permission
  const hasEdit = PERMISSIONS.permission_utilities_codelevel_edit;
  const hasAdd = PERMISSIONS.permission_utilities_codelevel_add;
  const hasDelete = PERMISSIONS.permission_utilities_codelevel_delete;
  const userPermissions = useRecoilValue(permissionsSelector);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (CodeLevelData.data) {
      setCodeLevelData(CodeLevelData.data);
    }
  }, [CodeLevelData.data]);

  //Filter
  const [codeLevelId, setCodeLevelId] = useState("");
  useEffect(() => {
    if (filterText) {
      setCodeLevelData(
        CodeLevelData.data?.filter((x) =>
          x.codeLevelName
            .toLowerCase()
            .includes(filterText.trim().toLowerCase())
        )
      );
    } else if (codeLevelId?.includes(".")) {
      let codeLevelIds = codeLevelId.split(".");
      const codeLevelIdsArr = codeLevelIds.map((id) => Number(id));
      const filteredData = CodeLevelData.data?.filter((x) =>
        codeLevelIdsArr.includes(x.codeLevelId)
      );

      setCodeLevelFilteredData(filteredData);
    } else if (codeLevelFilteredData?.length === 1) {
      const filteredData = CodeLevelData.data?.filter(
        (x) => x.codeLevelId === Number(codeLevelId)
      );

      setCodeLevelFilteredData(filteredData);
    } else {
      setCodeLevelData(CodeLevelData.data);
    }
    setEditState(false);
    setAddState(false);
  }, [filterText, CodeLevelData.data]);

  //Cancel
  const handleCancel = () => {
    setEditState(false);
    setAddState(false);
    setEditRowData();
    setDisabledButton(false);
    setNewData([newRow]);
    setUpdatedStatus(false);
  };

  //handle input fields changes
  const handlesFieldsChange = (fieldName, value) => {
    if (addState) {
      setNewData((data) => [{ ...data[0], [fieldName]: value }]);
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    } else {
      //else Edit State
      setEditRowData({
        ...editRowData,
        [fieldName]: value,
      });
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    }
  };

  //handle Add Button
  const handleAdd = () => {
    setAddState(true);
    setDisabledButton(true);
    setUpdatedStatus(true);
  };

  //handle Edit Button
  const handleEdit = (rowData) => {
    setEditState(true);
    setDisabledButton(true);
    setEditRowData({ ...rowData });
    setUpdatedStatus(rowData.isActive);
  };
  //save changes
  const handleSave = () => {
    setOpenModal(false);
    if (addState) {
      addCodeLevel(
        { ...newData },
        {
          onSuccess: (res) => {
            setDisabledButton(false);
            if (res.data === "duplicate") {
              toast.fire("Failed", "Code Level already exist", "error");
            } else if (res.status === 201) {
              setAddState(false);
              setNewData([newRow]);
              queryClient.invalidateQueries("GetCodeLevels");
              toast.fire(
                "Success",
                "New Code Level added successfully",
                "success"
              );
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Code Level",
                "error"
              );
            }
          },
          onError: (error) => {
            if (
              error.response.data.message === "Failed sending of email" ||
              error.response.data.message === "Failed inserting of notification"
            ) {
              toast.fire(
                "Success",
                "New Code Level added successfully, but " +
                  error.response.data.message,
                "warning"
              );
              queryClient.invalidateQueries("GetCodeLevels");
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Code Level",
                "error"
              );
            }
          },
        }
      );
    } else {
      //else for if c
      const codeLevelName = editRowData.codeLevelName.trim();
      const codeLevelDatas = codeLevelData.filter(
        (x) => x.codeLevelName === codeLevelName
      );
      if (
        codeLevelName === codeLevelDatas[0]?.codeLevelName &&
        editRowData.isActive === codeLevelDatas[0]?.isActive
      ) {
        toast.fire("Saving Failed", "No Changes have been made", "warning");
        setOpenModal(false);
      } else {
        editCodeLevel(editRowData);
      }
    }
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.codeLevelId);
    BulkDeleteCodeLevel(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  //validation
  useEffect(() => {
    if (
      newData[0].codeLevelName?.length > 0 ||
      editRowData?.codeLevelName?.length > 0
    ) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [newData[0], editRowData]);

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Code Levels" : "Code Level"
    }?`}</div>
  );

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setCodeLevelFilteredData(result);
          setCodeLevelId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
    setSelectedRows([]);
  }, []);

  const matColumns = [
    {
      title: "Code Level",
      field: "codeLevelName",
      customSort: (a, b) =>
        a.codeLevelName && b.codeLevelName
          ? a.codeLevelName.trim().localeCompare(b.codeLevelName.trim())
          : a.codeLevelName
          ? 0
          : -1,
      render: (rowData) => {
        return (rowData.codeLevelId === editRowData?.codeLevelId &&
          editState) ||
          addState ? (
          <div className="w-full">
            <div className="">
              <TextInput
                defaultValue={rowData.codeLevelName}
                onChange={(e) => {
                  handlesFieldsChange("codeLevelName", e.target.value);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="w-full text-quinary font-bold uppercase text-base">
            {rowData.codeLevelName}
          </div>
        );
      },
    },
    {
      title: "Created By",
      align: "left",
      field: "createdBy",
      hidden: addState || editState,
    },
    {
      title: "Created Date",
      align: "left",
      field: "createdDate",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      title: "Modified By",
      align: "left",
      field: "modifiedBy",
      hidden: addState || editState,
    },
    {
      title: "Modified Date",
      align: "left",
      field: "modifiedDate",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      field: "isActive",
      align: "left",
      title: "Status",
      render: (rowData) => {
        return (rowData.codeLevelId === editRowData?.codeLevelId &&
          editState) ||
          addState ? (
          <div className="flex justify-start place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handlesFieldsChange("isActive", e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {updatedStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      hidden: addState,
      render: (rowData) => {
        return (rowData.codeLevelId === editRowData?.codeLevelId &&
          editState) ||
          addState ? (
          <div className="flex justify-center space-x-1">
            <SaveButton
              buttonText="Save"
              disabled={
                disableSave ||
                (rowData?.codeLevelName === editRowData?.codeLevelName &&
                  rowData?.isActive === editRowData?.isActive)
              }
              onClick={() => {
                setOpenModal(true);
              }}
            />
            <CancelButton onClick={() => handleCancel()} />
          </div>
        ) : (
          <div className=" flex items-center place-content-center mr-5">
            {userPermissions.includes(hasEdit) && (
              <EditButton
                disabled={editState || selectedRows.length > 0}
                onClick={() => {
                  handleEdit(rowData);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];
  return (
    <div className="bg-white p-4 ">
      {!addState && (
        <>
          <div className="flex flex-row justify-between items-center">
            <TableFilters
              setMgaFilteredData={setMgaFilteredData}
              setDisChannelFilteredData={setDisChannelFilteredData}
              setCProgramFilteredData={setCProgramFilteredData}
              setLOBTypeFilteredData={setLOBTypeFilteredData}
              setProdCodeTypeFilteredData={setProdCodeTypeFilteredData}
              setCodeLevelFilteredData={setCodeLevelFilteredData}
              setFilterText={setFilterText}
              placeholder="Code Level Name"
              disabledButton={editState || selectedRows.length > 0}
            />

            <div className="">
              {userPermissions.includes(hasAdd) && (
                <AddButton
                  buttonText="New Code Level"
                  className={
                    selectedRows.length > 0 || editState
                      ? "opacity-50 float-right"
                      : "opacity-100 float-right"
                  }
                  onClick={() => handleAdd()}
                  disabled={editState || selectedRows.length > 0}
                />
              )}
            </div>
          </div>
          <div>
            {userPermissions.includes(hasDelete) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>
        </>
      )}
      <div
        className={
          addState ? "px-3 py-2 border-l-2  border-primary box-shadow" : ""
        }
      >
        {addState && (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold">
                Add New Code Level
              </div>
              <div className="flex items-center space-x-2 pt-2 pb-2">
                <SaveButton
                  buttonText="Save"
                  disabled={disableSave}
                  onClick={() => {
                    setOpenModal(true);
                  }}
                />
                <CancelButton onClick={() => handleCancel()} />
              </div>
            </div>
            <div className="h-0.5 w-full border-b-2 border-secondary " />
          </div>
        )}
        <div className={addState ? "py-2" : ""}>
          <MaterialProducerCodeConfigTable
            data={
              addState
                ? newData
                : codeLevelFilteredData?.length > 0
                ? codeLevelFilteredData
                : codeLevelData
            }
            isLoading={CodeLevelData.isFetching}
            columns={matColumns}
            isDeactivate={true}
            onSelectionChange={handleSelectedRowsChange}
            selectedRows={selectedRows}
            selection={
              !addState && !editState && userPermissions.includes(hasDelete)
            }
            setOpenModal={setOpenModalDelete}
            paging={!addState}
          />
          <div>
            <ConfirmBoxModal
              ModalTitle={addState ? "Add Code Level" : "Update Code Level"}
              qConfirmation={
                addState
                  ? "Are you sure you want to Add this?"
                  : " Are you sure you want to Update this?"
              }
              isOpen={openModal}
              onClose={() => setOpenModal(false)}
              onClickFunction={() => {
                handleSave();
              }}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Code Level"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeLevelTable;
